import { Grid, useMediaQuery, useTheme } from '@mui/material';

import { AccessManagementProvider } from 'components/ProfileSelectionCard/hooks';

import { AddAccountLayout } from './layout';
import { Container } from './styles';

export function AddAccountPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true,
  });
  return (
    <Container container spacing={3}>
      <Grid item xs={isMobile ? 10 : 6}>
        <AccessManagementProvider>
          <AddAccountLayout />
        </AccessManagementProvider>
      </Grid>
    </Container>
  );
}
